import GoogleMapsLoader from 'google-maps';
import './googleMaps.scss';

export function initGoogleMaps(el) {
  const {
    key, options, coords,
  } = el.dataset;
  const { lat, lng } = JSON.parse(coords);
  GoogleMapsLoader.KEY = key;
  return GoogleMapsLoader.load((google) => {
    const center = new google.maps.LatLng(lat, lng);
    const map = new google.maps.Map(el, {
      center,
      ...JSON.parse(options),
    });
    const marker = new google.maps.Marker({
      position: center,
    });
    marker.setMap(map);
  });
}
